import Header from "@components/Header";
import PageBody from "@components/PageBody";
import Footer from "@components/Footer";
import styles from "./index.module.css";
import { Button, Container, Stack, Text } from "@mantine/core";
import { Paths } from "@app/paths";
import { Link } from "react-router-dom";
import FormTextInput from "@/components/StyledTextInput/FormTextInput";
import useIntl from "@/infrastructure/hooks/useIntl";
import useForgotPassword from "./useForgotPassword";

function ForgotPassword() {
  const t = useIntl();
  const { handleSubmit, control } = useForgotPassword();

  return (
    <>
      <Header />
      <PageBody column>
        <Container size="md" className={styles.container}>
          <form onSubmit={handleSubmit}>
            <Stack align="stretch" justify="center">
              <h1 className={styles.title}>
                {t("forgotPassword.forgotPasswordTitle")}
              </h1>
              <FormTextInput
                control={control}
                name="email"
                label={t("forgotPassword.emailLabel")}
                size="md"
              />

              <Button size="md" type="submit">
                {t("forgotPassword.resetPasswordButtonTitle")}
              </Button>

              <Text ta="center" size="sm" mt="md">
                {t("forgotPassword.rememberPasswordText")}
                <Text td="underline" fw={600}>
                  <Link to={Paths.SignIn} replace>
                    {t("forgotPassword.signInHereLink")}
                  </Link>
                </Text>
              </Text>
            </Stack>
          </form>
        </Container>
      </PageBody>
      <Footer />
    </>
  );
}

export default ForgotPassword;
